var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaginationArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.302 11.191 5.311-5.85A.93.93 0 0 1 14.346 5q.44 0 .733.341l.62.674q.3.333.301.81c0 .317-.1.583-.302.817L11.74 12l3.96 4.368q.3.331.301.808c0 .318-.1.584-.301.818l-.62.674a.95.95 0 0 1-.733.332.95.95 0 0 1-.733-.332l-5.311-5.85A1.21 1.21 0 0 1 8 12q0-.476.302-.809"
})));
export default SvgPaginationArrowLeft;